import { Record as record } from 'immutable';

import { resolve, construct, fields } from '../helpers/LinkMapper';
import ValidityPeriod from './ValidityPeriod';

const defaults = {
    from: null,
    until: null,
    period: new ValidityPeriod({ days: 1 }),
    break: false
};

class Validity extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(Validity, json, {
            from: fields.datetime,
            until: fields.datetime,
            period: resolve.as(ValidityPeriod),
            break: fields.boolean
        });
    }
}


export default Validity;
